<template>
    <height-watcher>
        <div style="margin-top: 100px !important;display: flex; flex-direction: column; height: 300px; justify-content: center; align-items: center;">
            <div v-if="closedFromServer == false && callRejected == false && linkReceived == false" style="display: flex; flex-direction: column; height: 300px; justify-content: center; align-items: center;">
                <h3>{{ $t('live-communications.user-session-waiting') }}</h3>
                <h4 style="color: red">{{$t('live-communications.user-session-alert')}}</h4>
                <h6>{{ $t('live-communications.user-session-redirect') }}</h6>
                <h6>{{ $t('live-communications.total-guests-in-session') }} <b style="font-size: 30px !important">{{ total.length > 0 ?  $n(Number(total)) : '' }}</b></h6>
                <h6>{{ $t('live-communications.ahead-of-you') }} <b style="font-size: 30px !important">{{ ahead.length > 0 ? $n(Number(ahead)) : '' }}</b></h6>
                <a-button style="margin-top: 15px" type="primary" size="large" @click="leave">{{$t('live-communications.leave')}}</a-button>
            </div>
            <div>
                <div v-if="closedFromServer == true && linkReceived == false && callRejected == false" style="margin-top: 100px !important;display: flex; flex-direction: column; height: 300px; justify-content: center; align-items: center;">
                    <h3 style="text-align: center;">{{ $t('live-communications.live-session-ended') }}</h3>
                    <a-button style="margin-top: 15px" type="primary" size="large" @click="navigateTo('Index')">{{$t('apply.done-step.btn-caption')}}</a-button>
                </div>
            </div>
            <div>
                <div v-if="callRejected == true" style="margin-top: 100px !important;display: flex; flex-direction: column; height: 300px; justify-content: center; align-items: center;">
                    <h3 style="text-align: center;">{{ $t('live-communications.call-rejected') }}</h3>
                    <a-button style="margin-top: 15px" type="primary" size="large" @click="navigateTo('Index')">{{$t('apply.done-step.btn-caption')}}</a-button>
                </div>
            </div>
        </div>
    </height-watcher>
</template>

<script>
import HeightWatcher from "../../components/height-watcher/HeightWatcher.vue";
import { wsUrl } from '../../api/config';
import { navigationMixin } from '../../mixins/navigation-mixin';

export default {
    props: {
        authData: {
            type: Object,
            required: false,
        }
    },
    components: {
        HeightWatcher,
    },
    mixins: [ navigationMixin ],
    data() {
        return {
            ws: null,
            total: '',
            ahead: '',
            closedFromServer: false,
            callRejected: false,
            linkReceived: false
        }
    },
    methods: {
        connect() {
            this.ws = new WebSocket(wsUrl);
            this.ws.onopen = () => {
                this.connectivityStatus = 'CONNECTED'; 
                console.log('Opened'); 
                /* send authentication data */
                let authData = {
                    type: "anonym_auth",
                    params: {
                        name: this.authData.name,
                        mobile: this.authData.mobile,
                        address: this.authData.address,
                        purpose: this.authData.purpose,
                        targetOfficial: this.authData.officialId,
                        appName: this.authData.appName
                    }
                };
                this.ws.send(JSON.stringify(authData));
                
            }
            this.ws.onclose = (event) => {
                this.connectivityStatus = 'DISCONNECTED';
                if (event.code != 1000) {
                    console.log('[close] Connection died .. should reconnect');
                    this.connectivityStatus = 'RECONNECTING';
                    setTimeout(() => {
                        this.connect();
                    }, 10000);
                } else {
                    console.log(`Web Socket was closed by user code=${event.code} reason=${event.reason}`);
                    if (!this.callRejected)
                        this.closedFromServer = true;
                }
            };
            this.ws.onerror = (error) => {
                this.connectivityStatus = 'DISCONNECTED';
                console.log(`[error] ${error.message} .. should reconnect`);
            };
            this.ws.onmessage = (event) => {
                let data = JSON.parse(event.data);

                if (data.type == 'ping') {
                    this.ws.send(JSON.stringify({ type: "pong", params: {} }));
                } else {
                    if (data.type == 'call') {
                        if (data.params.guest.mobile == this.authData.mobile) {
                            this.linkReceived = true;
                            this.ws.send(JSON.stringify({ type: 'call_accepted', params:  { 
                                name: this.authData.name, 
                                mobile: this.authData.mobile, 
                                address: this.authData.address, 
                                purpose: this.authData.purpose, 
                                targetOfficial: this.authData.officialId, 
                                appName: this.authData.appName 
                            }}));
                            
                            setTimeout(() => {
                                window.location = data.params.link;
                            }, 1000);
                        }
                    } else if (data.type == 'queue_update') {
                        this.total = data.params.total + '';
                        this.ahead = (data.params.index) + '';
                    } else if (data.type == 'call_rejected') {
                        console.log(data);
                        this.closedFromServer = false;
                        this.callRejected = true;
                        if (this.ws) {
                            this.ws.send(JSON.stringify({ type: 'call_rejected_ack', params: data.params }));
                        }
                    }
                }
            };
        },
        leave() {
            if (this.ws) {
                this.ws.send(JSON.stringify({ type: 'leave', params:  { 
                        name: this.authData.name, 
                        mobile: this.authData.mobile, 
                        address: this.authData.address, 
                        purpose: this.authData.purpose, 
                        targetOfficial: this.authData.officialId, 
                        appName: this.authData.appName 
                    } 
                }));
            }
            
            this.navigateTo('Index');
        }
    },
    beforeDestroy() {
        if (this.ws) {
            this.ws.send(JSON.stringify({ type: 'leave', params:  { 
                    name: this.authData.name, 
                    mobile: this.authData.mobile, 
                    address: this.authData.address, 
                    purpose: this.authData.purpose, 
                    targetOfficial: this.authData.officialId, 
                    appName: this.authData.appName 
                } 
            }));
        }
        
    },
    mounted() {
        console.log(wsUrl);
        this.connect();
    }

}
</script>